export default __webpack_public_path__ + "static/media/section2_bg_2.c7dc5ab4.png";